import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// 구독제 이용권 표시용 teal 뱃지. 구독 상품이 노출되는 곳(이용권 목록, 판매등록 이용권 선택 등)에서
// 공용으로 사용해 스타일을 한 곳에서 관리한다. 간격(margin)은 사용처에서 sx로 조절.
const StyledBadge = styled(Box)({
  display: 'inline-block',
  verticalAlign: 'middle',
  flexShrink: 0,
  padding: '1px 6px',
  borderRadius: 4,
  fontSize: 11,
  fontWeight: 600,
  lineHeight: 1.6,
  color: '#0F7F85',
  border: '1px solid #0F7F85',
  whiteSpace: 'nowrap',
});

const CommonSubscriptionBadge = ({ children = '구독', ...rest }) => <StyledBadge {...rest}>{children}</StyledBadge>;

export default CommonSubscriptionBadge;
